<template>
  <div class="portfolio-case-study container" id="trofi">
    <CsVideoIntro
      v-bind="project.caseStudy.intro"
      :posterImage="project.posterImage"
    ></CsVideoIntro>
    <CsSynopsis v-bind="project.caseStudy.synopsis"></CsSynopsis>
    <CsShowcase v-bind="project.caseStudy.showcase"></CsShowcase>
    <CsImageGrid
      @loaded="mountTrigger"
      v-bind="project.caseStudy.imageGrid"
    ></CsImageGrid>

    <!-- <div class="cs-project-credits">
			<div class="cs-project-credits-content">
				<h3>Project Credits & Details</h3>
				<ul>
					<li>
						<span>Associated Agency</span>
						<span>Architecto omnis quibusdam ab corrupti quam</span>
					</li>
					<li>
						<span>Assistant Jr. Developer</span>
						<span>Nelson Khiev</span>
					</li>
					<li>
						<span>Assistant Jr. Developer</span>
						<span>Nelson Khiev</span>
					</li>
					<li>
						<span>Assistant Jr. Developer</span>
						<span>Nelson Khiev</span>
					</li>
				</ul>
			</div>
		</div> -->
    <CallToAction v-if="mountReady" v-bind="cta" />
  </div>
</template>

<script>
import { brantonAgency, cta } from "@/data/projects.js";
import CallToAction from "@/components/CallToAction";
import CsVideoIntro from "@/components/CsVideoIntro/CsVideoIntro";
import CsSynopsis from "@/components/CsSynopsis/CsSynopsis";
import CsShowcase from "@/components/CsShowcase/CsShowcase";
import CsImageGrid from "@/components/CsImageGrid/CsImageGrid";

export default {
  name: "Branton",
  metaInfo: {
    title: `Branton Agency`,
    meta: [
      {
        name: "description",
        content: `An agency website built for Branton, a full-service marketing agency that specializes in helping businesses grow.`,
      },
    ],
  },
  data() {
    return {
      project: brantonAgency,
      mountReady: false,
      cta: cta,
    };
  },
  components: {
    CallToAction,
    CsVideoIntro,
    CsSynopsis,
    CsShowcase,
    CsImageGrid,
  },
  methods: {
    mountTrigger(val) {
      this.mountReady = val;
    },
  },
};
</script>
